import { render, staticRenderFns } from "./ActivityTreeNodeBookmarkTable.global.vue?vue&type=template&id=49b2acc5&lang=pug&"
import script from "./ActivityTreeNodeBookmarkTable.global.vue?vue&type=script&lang=ts&"
export * from "./ActivityTreeNodeBookmarkTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports